/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ClientError } from '../model/clientError.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class CoefficientControllerService {

    protected basePath = 'http://localhost/assets-backend/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(@Inject(HttpClient) protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Inject(Configuration) @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param katuzeKod 
     * @param parcelId 
     * @param drupozKod 
     * @param zpvypoKod 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoefficientX(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getCoefficientX(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getCoefficientX(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getCoefficientX(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (katuzeKod === null || katuzeKod === undefined) {
            throw new Error('Required parameter katuzeKod was null or undefined when calling getCoefficientX.');
        }
        if (parcelId === null || parcelId === undefined) {
            throw new Error('Required parameter parcelId was null or undefined when calling getCoefficientX.');
        }
        if (drupozKod === null || drupozKod === undefined) {
            throw new Error('Required parameter drupozKod was null or undefined when calling getCoefficientX.');
        }
        if (zpvypoKod === null || zpvypoKod === undefined) {
            throw new Error('Required parameter zpvypoKod was null or undefined when calling getCoefficientX.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (katuzeKod !== undefined && katuzeKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>katuzeKod, 'katuzeKod');
        }
        if (parcelId !== undefined && parcelId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parcelId, 'parcelId');
        }
        if (drupozKod !== undefined && drupozKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>drupozKod, 'drupozKod');
        }
        if (zpvypoKod !== undefined && zpvypoKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zpvypoKod, 'zpvypoKod');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/app/coefficient/x`;
        return this.httpClient.request<number>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param katuzeKod 
     * @param parcelId 
     * @param drupozKod 
     * @param zpvypoKod 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoefficientY(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getCoefficientY(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getCoefficientY(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getCoefficientY(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (katuzeKod === null || katuzeKod === undefined) {
            throw new Error('Required parameter katuzeKod was null or undefined when calling getCoefficientY.');
        }
        if (parcelId === null || parcelId === undefined) {
            throw new Error('Required parameter parcelId was null or undefined when calling getCoefficientY.');
        }
        if (drupozKod === null || drupozKod === undefined) {
            throw new Error('Required parameter drupozKod was null or undefined when calling getCoefficientY.');
        }
        if (zpvypoKod === null || zpvypoKod === undefined) {
            throw new Error('Required parameter zpvypoKod was null or undefined when calling getCoefficientY.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (katuzeKod !== undefined && katuzeKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>katuzeKod, 'katuzeKod');
        }
        if (parcelId !== undefined && parcelId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parcelId, 'parcelId');
        }
        if (drupozKod !== undefined && drupozKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>drupozKod, 'drupozKod');
        }
        if (zpvypoKod !== undefined && zpvypoKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zpvypoKod, 'zpvypoKod');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/app/coefficient/y`;
        return this.httpClient.request<number>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param katuzeKod 
     * @param parcelId 
     * @param drupozKod 
     * @param zpvypoKod 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLocalCoefficient(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<number>;
    public getLocalCoefficient(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<number>>;
    public getLocalCoefficient(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<number>>;
    public getLocalCoefficient(katuzeKod: number, parcelId: number, drupozKod: number, zpvypoKod: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (katuzeKod === null || katuzeKod === undefined) {
            throw new Error('Required parameter katuzeKod was null or undefined when calling getLocalCoefficient.');
        }
        if (parcelId === null || parcelId === undefined) {
            throw new Error('Required parameter parcelId was null or undefined when calling getLocalCoefficient.');
        }
        if (drupozKod === null || drupozKod === undefined) {
            throw new Error('Required parameter drupozKod was null or undefined when calling getLocalCoefficient.');
        }
        if (zpvypoKod === null || zpvypoKod === undefined) {
            throw new Error('Required parameter zpvypoKod was null or undefined when calling getLocalCoefficient.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (katuzeKod !== undefined && katuzeKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>katuzeKod, 'katuzeKod');
        }
        if (parcelId !== undefined && parcelId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parcelId, 'parcelId');
        }
        if (drupozKod !== undefined && drupozKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>drupozKod, 'drupozKod');
        }
        if (zpvypoKod !== undefined && zpvypoKod !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zpvypoKod, 'zpvypoKod');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/app/coefficient/local`;
        return this.httpClient.request<number>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
